// Angular
import { Injectable } from '@angular/core';

// Interfaces
import { IUpdatedUser, IUser } from '../../interfaces/seacom/user';

// Services
import { ApiNodeService } from './templates/apinode.service';
import { SeacomApiService } from './seacom-api.service';


@Injectable({
  providedIn: 'root'
})
export class UsersService extends ApiNodeService<IUser, IUser, IUpdatedUser> {
  node = 'accounts';

  constructor(public seacomApiService: SeacomApiService) {
    super(seacomApiService);
  }

  public create: undefined;
}
